import axios from "axios";

export const useAxios = () => {
	return axios.create({
		baseURL: 'https://sms-app-v1-test.herokuapp.com/api/v1',
		timeout: 30000
	})
}
